module.exports = __webpack_public_path__ + "fonts/HMpangram-ExtraLight.43e11fff.ttf";